<script>
    import { onMount } from "svelte";

    import Loader from "../components/Loader.svelte";
    import SubscriptionMessage from "../components/SubscriptionMessage.svelte";

    import { currentLocation } from "../stores.js";

    onMount(() => {
        currentLocation.set("import");
    });

    const music = MusicKit.getInstance();

    let initiated = false;

    let loading = false;
    let progressMessage = undefined;

    let libraryText = "";

    async function parseLibraryData() {
        const data = JSON.parse(libraryText);
        return {
            songs: data.songs.map(songId => songId.toString()),
            playlists: data.playlists.map(playlist => ({
                attributes: {
                    name: playlist?.attributes?.name?.toString() ?? "",
                    description: playlist?.attributes?.description?.toString() ?? "",
                },
                tracks: playlist.tracks.map(songId => songId.toString()),
            })),
        };
    }

    async function importSongs(libraryData) {
        const chunkSize = 50;

        let chunkOffset = 0;
        let requestCount = 0;

        let imported = [];

        while (chunkOffset < libraryData.songs.length) {
            const nextChunkOffset = chunkOffset + chunkSize;
            const chunk = libraryData.songs.slice(chunkOffset, nextChunkOffset);

            progressMessage = `Importing Songs (added ${imported.length} songs over ${requestCount} requests)`;
            await music.api.music(
                `/v1/me/library`,
                { "ids[songs]": chunk },
                { fetchOptions: { method: "POST" } },
            );

            imported.push(...chunk);
            console.log(imported);

            chunkOffset = nextChunkOffset;
        }

        return imported;
    }

    async function importPlaylists(libraryData) {
        let imported = [];
        let requestCount = 0;

        for (const playlist of libraryData.playlists) {
            progressMessage = `Importing Playlists (added ${imported.length} playlists over ${requestCount} requests)`;

            const body = {
                attributes: {
                    name: playlist.name,
                    description: playlist.description,
                },
                relationships: {
                    tracks: {
                        data: playlist.tracks.map((track) => ({ type: "songs", id: track })),
                    },
                },
            };

            const fetchOptions = {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(body),
            };

            await music.api.music(
                `/v1/me/library/playlists`,
                {},
                { fetchOptions },
            );

            imported.push(playlist);
            console.log(imported);
        }

        return imported;
    }

    let importedSongs = undefined;
    let importedPlaylists = undefined;

    function handleLibraryImport() {
        loading = true;
        (async () => {
            try {
                const libraryData = await parseLibraryData();
                importedSongs = await importSongs(libraryData);
                importedPlaylists = await importPlaylists(libraryData);
                initiated = true;
            } catch (err) {
                console.error(err);
            } finally {
                loading = false;
            }
        })();
    }

    function handleKeyDown() {}
</script>

<div class="root centered">
    {#if music.isAuthorized}
        {#if loading}
            <div class="loader-container vstack centered">
                <div><Loader /></div>
                <div>{progressMessage}</div>
            </div>
        {:else if !initiated}
            <div class="import-text-container vstack centered">
                <textarea class="import-text" bind:value={libraryText} on:keydown|stopPropagation={handleKeyDown} />
                <div class="button" on:click={handleLibraryImport}>
                    Import Library
                </div>
            </div>
        {:else}
            <div class="centered">
                TODO
            </div>
        {/if}
    {:else}
        <SubscriptionMessage />
    {/if}
</div>

<style>
    .root {
        width: 100%;
        height: 100%;
        position: relative;
        color: var(--app-fg-color);
    }

    .loader-container {
        gap: 20px;
    }

    .button {
        border: solid 2px var(--app-fg-color);
        border-radius: 5px;
        padding: 10px 20px;
        cursor: pointer;
    }

    .button:hover {
        color: var(--app-bg-color);
        background-color: var(--app-fg-color);
    }

    .import-text-container {
        gap: 10px;
    }

    .import-text {
        width: 600px;
        height: 400px;
        background-color: inherit;
        color: inherit;
        border-radius: 5px;
        border: solid 2px var(--app-fg-color);
        padding: 5px;
        font-family: inherit;
        font-size: inherit;
    }

    .library-container {
        gap: 10px;
    }

    .library {
        gap: 10px;

        --song-item-padding: 5px;
    }

    .known, .unknown {
        gap: 5px;
    }

    .known-title, .unknown-title {
        font-size: 20px;
        font-weight: bold;
        text-align: center;
        width: 100%;
        padding: 10px;
        border: solid 2px var(--app-fg-color);
        border-radius: 5px;
        box-sizing: border-box;
    }

    .see-more {
        padding: 5px 0;
    }

    .known-items, .unknown-items {
        width: 500px;
        height: 500px;
        gap: 5px;
        overflow-y: auto;
        padding: 10px;
        border: solid 2px var(--app-fg-color);
        border-radius: 5px;
    }
</style>
